import { Routes } from '@angular/router';
import {
  BreadCrumbRouteConfig,
  RenderInterfaceGuard
} from 'viggo-sistemas-core-web';

export const routesSysadminDefault: Routes = [
  {
    path: 'user',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      breadcrumb: {
        label: 'Usuário',
        icon: 'pi pi-fw pi-user'
      },
      module: 'USER',
      backend_path: '/users'
    },
    loadChildren: () =>
      import('@app/modules/wrapperModules/user/user-wrapper.module').then(
        m => m.UserWrapperModule
      )
  },
  {
    path: 'support-user',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      breadcrumb: {
        label: 'Usuários por domínio',
        icon: 'pi pi-fw pi-users'
      },
      module: 'SUPORTE_USER',
      backend_path: '/users'
    },
    loadChildren: () =>
      import('@app/modules/wrapperModules/support-wrapper.module').then(
        m => m.SupportWrapperModule
      )
  },
  {
    path: 'erro-integracao',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'ERRO_INTEGRACAO',
      breadcrumb: {
        label: 'Erros da integração',
        icon: 'pi pi-fw pi-times-circle'
      },
      backend_path: '/erro_integracaos'
    },
    loadChildren: () =>
      import('@app/modules/error_integration/error_integration.module').then(
        m => m.ErrorIntegrationModule
      )
  },
  {
    path: 'application',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'APPLICATION',
      breadcrumb: {
        icon: 'pi pi-fw pi-building',
        label: 'Aplicações'
      },
      backend_path: '/applications',
      appConfig: {
        showButtonConfig: true,
        regras: [
          {
            name: 'Tipo de perfil',
            key: 'tipo_perfil',
            checkbox: false,
            options: [
              { label: 'Atacado', value: 'ATACADO' },
              { label: 'Varejo', value: 'VAREJO' }
            ],
            value: ''
          },
          {
            name: 'Dados via integração',
            key: 'usa_integracao',
            checkbox: true,
            value: false
          }
        ]
      }
    },
    loadChildren: () =>
      import('@app/modules/wrapperModules/application-wrapper.module').then(
        m => m.ApplicationWrappereModule
      )
  },
  {
    path: 'route',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'ROUTE',
      breadcrumb: {
        icon: 'pi pi-fw pi-directions',
        label: 'Rotas'
      },
      backend_path: '/routes'
    },
    loadChildren: () =>
      import('@app/modules/wrapperModules/rota-wrapper.module').then(
        m => m.RouterWrapperModule
      )
  },
  {
    path: 'role',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'ROLE',
      breadcrumb: {
        icon: 'pi pi-fw pi-users',
        label: 'Papéis de usuário'
      },
      backend_path: '/roles'
    },
    loadChildren: () =>
      import('@app/modules/wrapperModules/role-wrapper.module').then(
        m => m.RoleWrapperModule
      )
  },
  {
    path: 'domain',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      breadcrumb: {
        icon: 'pi pi-fw pi-briefcase',
        label: 'Organização'
      },
      module: 'DOMAIN',
      backend_path: '/domains'
    },
    loadChildren: () =>
      import('@app/modules/wrapperModules/domain-wrapper.module').then(
        m => m.DomainWrapperModule
      )
  },
  {
    path: 'iniciar_subrotina',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'INICIAR_SUBROTINA',
      breadcrumb: {
        label: 'Sub-rotinas da integração',
        icon: 'pi pi-fw pi-code'
      } as BreadCrumbRouteConfig
    },
    loadChildren: () =>
      import('@app/modules/subrotinas/subrotina.module').then(
        m => m.SubrotinaModule
      )
  },
  {
    path: 'erro-integracoes-externas',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'ERRO_INTEGRACAO_EXTERNA',
      breadcrumb: {
        label: 'Log de erro das integrações externas',
        icon: 'pi pi-fw pi-times-circle'
      },
      backend_path: '/log_erro_integracao_externas'
    },
    loadChildren: () =>
      import(
        '@app/modules/log_erro_integracao_externa/log_erro_integracao_externa.module'
      ).then(m => m.LogErroIntegracaoExtModule)
  }
];
